import {UGLInstructionReactor} from "../../UGLInstructionReactor";

export const logInstruction: UGLInstructionReactor = {
    run: (instruction, ctx) => {
        console.log(ctx.params[0])
    }
}
